<template>
    <div class="wrappert">
        <img ref="gamecanvas" src="http://placehold.it/500x500?text=i_r_canvas" />
        <v-snowsplosion ref="splosion" :size="snowWidth * 2" :complexity="1" :autoAnimate="true" :autoFadeOut="true"></v-snowsplosion>
    </div>
</template>

<style lang="scss" scoped>
    .wrappert{
        position:relative;
        margin-top:200px;

        .snowsplosion-wrapper{
            top:50%;
            left:50%;
        }
    }
</style>

<script>
    import Snowsplosion from '@/app/components/Snowsplosion';

    export default {

        components: {
            'v-snowsplosion': Snowsplosion
        },

        data()
        {
            return {
                snowWidth: 500 * 1.3448673587081891580161476355248, // magic num = 1166 / 867 (orig asset ratios)
                status: 'lost'
            };
        },

        mounted()
        {

        },

        methods: {

        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Sanity.vue